import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoItemsGetReq } from "./abst/DtoItemsGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoItemsGetReqImple extends DtoItemsGetReq {
  // 商品マスタ一覧の検索条件
  public itemManagName: string | null = null;
  public itemName: string | null = null;
  public itemType: string | null = null;
  public itemOwner: string | null = null;
  public itemArea: string | null = null;
  public itemTerm: string | null = null;

  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
